/*
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */

import { DOCUMENT } from "@angular/common";
import { Component, ElementRef, Inject, OnInit, Renderer2 } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { AppSettings } from "./app.settings";
import { EnvService } from "./env.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false
})
export class AppComponent implements OnInit {
  constructor(public elementRef: ElementRef,
              public translate: TranslateService,
              private environmentSettings: EnvService,
              private titleService: Title,
              @Inject(DOCUMENT) private document: Document,
              private renderer: Renderer2) {
  }

  ngOnInit(): void {
    AppSettings.init(this.elementRef.nativeElement.dataset, this.environmentSettings);

    const darkMode = new URLSearchParams(this.document.location.search).get("darkMode") === "true";
    if (darkMode) {
      this.renderer.setAttribute(this.document.documentElement, "data-theme-type", "dark");
    } else {
      this.renderer.removeAttribute(this.document.documentElement, "data-theme-type");
    }

    this.translate.addLangs(this.environmentSettings.SupportedLocales);
    this.translate.setDefaultLang(this.environmentSettings.DefaultLocale);

    // Change the title on the anchor page (i.e. the index.html page) based
    // on our locale.
    this.translate.get("title").subscribe((translatedTitle: string) => {
      this.titleService.setTitle(translatedTitle);
    });
  }
}
